import GreyColumn from '../GreyColumn'
import classNames from '@ui-components-3/ui/lib/utils/classNames'
import { FC, useMemo } from 'react'

type HorizontalRowsInfoProps = {
  gender?: string
  dob?: string
  pronoun?: string
  height?: string | number
  weight?: string | number
  degreeClassification?: string
  graduationYear?: string
  graduationSemester?: string
  major?: string[]
  studentExperiences?: string[]
  className?: string
}

const HorizontalRowsInfo: FC<HorizontalRowsInfoProps> = ({
  gender,
  dob,
  height,
  weight,
  degreeClassification,
  graduationYear,
  graduationSemester,
  major,
  studentExperiences,
  pronoun,
  className,
}) => {
  const rows = useMemo(
    () =>
      [
        { label: 'Sex', value: gender },
        { label: 'Dob', value: dob },
        { label: 'Height', value: height },
        { label: 'Weight', value: weight },
        { label: 'Classification', value: degreeClassification },
        { label: 'Graduation Year', value: graduationYear },
        { label: 'Graduation Semester', value: graduationSemester },
        { label: 'Major', value: major },
        { label: 'Experiences', value: studentExperiences },
        { label: 'Preferred Pronouns', value: pronoun },
      ].filter(({ value }) => !!value || value === 0),
    [
      degreeClassification,
      dob,
      studentExperiences,
      gender,
      graduationSemester,
      graduationYear,
      height,
      major,
      pronoun,
      weight,
    ],
  )

  return (
    <div className={classNames('flex flex-wrap w-[90%] mt-1.5', className)}>
      {rows.map(({ label, value }) => (
        <GreyColumn label={label} value={value} key={label} />
      ))}
    </div>
  )
}

export default HorizontalRowsInfo
